<template>
  <div class="__DevTools-Flags">
    <q-option-group v-model="enabledItems" :options="flagOptions" type="checkbox" />
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

export default Vue.extend({
  name: 'DevToolFlags',
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  computed: {
    ...mapGetters('devTools', ['getFlags']),

    enabledItems: {
      get() {
        return this.getFlags.filter(i => i.enabled).map(i => i.feature_id);
      },
      set(val) {
        this.changeFlagEnabled(val);
      },
    },

    flagOptions() {
      return this.getFlags.map(i => {
        return {
          label: i.feature_name,
          value: i.feature_id,
          disable: this.disabled,
        };
      });
    },
  },
  methods: {
    ...mapActions('devTools', ['changeFlagEnabled']),
  },
});
</script>
